<template>
  <div class="station-form-category-container">
    <span class="station-form-category-title">Informações do plantão</span>
    <div class="station-form-category-content">
      <div class="station-form-category-columns text-left justify-start">
        <div class="flex flex-col">
          <span class="text-sg">Nossa equipe</span>
          <v-radio-group @update:model-value="setOurTeam" :model-value="ourTeam" column>
            <v-radio label="Sim" color="primary" :value="true" />
            <v-radio label="Não" color="primary" :value="false" />
          </v-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps(['ourTeam'])
const emit = defineEmits(['update:ourTeam'])
const setOurTeam = (v: boolean) => emit('update:ourTeam', v)
</script>
